/* ATR Studio custom theme v7 */
(function () {
  function init() {
    // Mobile menu
    var menuBtn = document.querySelector('.menu-btn');
    var mnav = document.getElementById('mnav');
    if (menuBtn && mnav && !menuBtn.dataset.atrInit) {
      menuBtn.dataset.atrInit = '1';
      menuBtn.addEventListener('click', function () {
        mnav.classList.toggle('open');
        menuBtn.setAttribute('aria-expanded', mnav.classList.contains('open'));
        menuBtn.setAttribute('aria-label', mnav.classList.contains('open') ? 'Close menu' : 'Open menu');
      });
      document.addEventListener('keydown', function (e) { if(e.key === 'Escape' && mnav.classList.contains('open')) { mnav.classList.remove('open'); menuBtn.setAttribute('aria-expanded','false'); menuBtn.setAttribute('aria-label','Open menu'); menuBtn.focus(); } });
      mnav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { mnav.classList.remove('open'); menuBtn.setAttribute('aria-expanded', 'false'); });
      });
    }

    // Product carousels (home "The drop", "Also in the drop")
    document.querySelectorAll('.shop-wrap').forEach(function (wrap) {
      var scroller = wrap.querySelector('.shop');
      if (!scroller || wrap.dataset.atrInit) return;
      wrap.dataset.atrInit = '1';
      var prev = wrap.querySelector('.shop-nav.prev');
      var next = wrap.querySelector('.shop-nav.next');
      function cardStep() {
        var item = scroller.querySelector('[data-atr-card]');
        return item ? item.getBoundingClientRect().width : 300;
      }
      function update() {
        var scrollable = scroller.scrollWidth > scroller.clientWidth + 4;
        wrap.classList.toggle('is-scrollable', scrollable);
        if (!prev || !next) return;
        var max = scroller.scrollWidth - scroller.clientWidth - 2;
        prev.disabled = scroller.scrollLeft <= 2;
        next.disabled = scroller.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    // Product page: media gallery
    document.querySelectorAll('.product-media').forEach(function (media) {
      var strip = media.querySelector('.product-media-strip');
      if (!strip || media.dataset.atrInit) return;
      media.dataset.atrInit = '1';
      var slides = strip.querySelectorAll('.product-media-slide');
      var dots = Array.prototype.slice.call(media.querySelectorAll('.product-dot'));
      var arrows = media.querySelectorAll('.media-arrow');
      if (slides.length > 1) media.classList.add('has-many');
      function current() { return Math.round(strip.scrollLeft / strip.clientWidth); }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        strip.scrollTo({ left: i * strip.clientWidth, behavior: 'smooth' });
      }
      function onScroll() {
        var idx = current();
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }
      strip.addEventListener('scroll', onScroll, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.idx, 10)); }); });
      arrows.forEach(function (a) {
        a.addEventListener('click', function () { goTo(current() + (a.classList.contains('next') ? 1 : -1)); });
      });
    });

    // Product page: variant picker (single option products, e.g. Size)
    document.querySelectorAll('.variant-group').forEach(function (group) {
      var form = group.closest('form');
      if (!form || form.hasAttribute('data-atr-product-form') || group.dataset.atrInit) return;
      group.dataset.atrInit = '1';
      var hiddenInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var addBtn = form.querySelector('.add-cart-btn');
      group.querySelectorAll('.variant-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          if (hiddenInput) hiddenInput.value = btn.dataset.variantId;
          if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
          if (addBtn) {
            var available = btn.dataset.available === 'true';
            addBtn.disabled = !available;
            addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
          }
        });
      });
    });

    // Enquiry form: scroll to message after a Shopify contact form submission
    var msg = document.querySelector('.form-msg');
    if (msg && (window.location.hash.indexOf('contact_form') !== -1 || window.location.hash.indexOf('enquiry-form') !== -1)) {
      msg.scrollIntoView({ block: 'center' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', init);
})();



